import { func, object } from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Input } from '@eika/input';
import ErrorMessage from '../../errormessage';

const RrPep = ({ question, getLabel, getHandleChange, errors, ekstratekster, getHelpBody }) => {
    return (
        <>
            <div className={classNames({ 'has-error error': errors.includes('pepVerv') })}>
                <Input
                    type="text"
                    className="rr-pepVerv"
                    label={getLabel(ekstratekster, 'rr_peptype')}
                    name={`pepVerv-${question.rrId}`}
                    onChange={getHandleChange('pepVerv')}
                    value={question.pepVerv || ''}
                    modalHelpHeader={ekstratekster.rr_pepVerv_infotittel}
                    modalHelpBody={getHelpBody(ekstratekster, 'rr_pepVerv_info')}
                />
                {errors.includes('pepVerv') && <ErrorMessage text={getLabel(ekstratekster, 'rr_pepVerv_instruks')} />}
            </div>
            <div
                className={classNames(
                    { 'has-error error': errors.includes('pepRelasjon') },
                    'skjema-input-field-wrap-small skjema-input-field-wrap'
                )}
            >
                <Input
                    type="text"
                    className="rr-pepRelasjon"
                    label={getLabel(ekstratekster, 'rr_peprelasjon')}
                    name={`pepRelasjon-${question.rrId}`}
                    onChange={getHandleChange('pepRelasjon')}
                    value={question.pepRelasjon || ''}
                    modalHelpHeader={ekstratekster.rr_pepRelasjon_infotittel}
                    modalHelpBody={getHelpBody(ekstratekster, 'rr_pepRelasjon_info')}
                />
                {errors.includes('pepRelasjon') && (
                    <ErrorMessage text={getLabel(ekstratekster, 'rr_pepRelasjon_instruks')} />
                )}
            </div>
        </>
    );
};

RrPep.propTypes = {
    question: object.isRequired,
    getLabel: func.isRequired,
    getHandleChange: func.isRequired,
    errors: object.isRequired,
    ekstratekster: object.isRequired,
    getHelpBody: func.isRequired,
};

export default React.memo(RrPep);
